import { useTranslation } from 'react-i18next';

import { Table, TTableColumn, TextSkeleton } from '@treezor/design-system';

export function CompanyMemberLoader() {
  const { t } = useTranslation();

  const rows = new Array(8).fill(undefined).map((_) => ({}));

  type TData = (typeof rows)[number];

  const columns: TTableColumn<TData>[] = [
    {
      label: '',
      name: 'user',
      cellRenderer: () => <TextSkeleton />,
    },
    {
      label: t('pages.dashboard.users.table.userTypeId'),
      name: 'userType',
      cellRenderer: () => <TextSkeleton />,
    },

    {
      label: t('pages.dashboard.users.table.userStatus'),
      name: 'status',
      cellRenderer: () => <TextSkeleton />,
    },

    {
      label: t('pages.dashboard.users.table.kycStatus'),
      name: 'kycStatus',
      cellRenderer: () => <TextSkeleton />,
    },

    {
      label: t('pages.dashboard.users.table.creationDate'),
      name: 'createdDate',
      cellRenderer: () => <TextSkeleton />,
    },
  ];

  return <Table columns={columns} rows={rows} />;
}
export default CompanyMemberLoader;
